// adapted from https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Testing_for_availability
function isStorageAvailable() {
  let storage;
  try {
    storage = window.localStorage;
    const test = '__test__';
    storage.setItem(test, test);
    storage.removeItem(test);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      (e.name === 'QuotaExceededError' ||
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      storage &&
      storage.length !== 0
    );
  }
}

const storage = {
  isAvailable: isStorageAvailable(),

  getSync(key: string) {
    if (this.isAvailable) {
      const rawValue = localStorage.getItem(key);
      if (rawValue !== null) {
        return JSON.parse(rawValue);
      }
    }
    return null;
  },

  async get(key: string) {
    return this.getSync(key);
  },

  async set(key: string, value: string | string[] | number | boolean) {
    if (this.isAvailable) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  },

  async remove(key: string) {
    if (this.isAvailable) {
      localStorage.removeItem(key);
    }
  },
};

export default storage;
